import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Orders from "../pages/Order/index";
import OrderDetails from "../pages/Order/view";
import Shops from "../pages/Shops";
import Category from "../pages/Category";
import Variants from "../pages/Variants";
import Attributes from "../pages/Attributes";
import Products from "../pages/Products";
import CreateProduct from "../pages/Products/craete";
import CreatOrder from "../pages/Order/create";
import Transactions from "../pages/Transcations";
import Settings from "../pages/Settings";
import UpdateProduct from "../pages/Products/update";
import DraftOrders from "../pages/Order/draftOrders";
import Consumers from "../pages/Consumers";
import ConsumerTransactions from "../pages/Consumers/transactions";
import QRScanner from "../pages/QR";

const protectedRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/orders", element: <Orders /> },
  { path: "/create-order", element: <CreatOrder /> },
  { path: "/create-custom-order", element: <CreatOrder /> },
  { path: "/orderdetails/:id", element: <OrderDetails /> },
  { path: "/transcations", element: <Transactions /> },
  { path: "/consumer-transactions", element: <ConsumerTransactions /> },
  { path: "/shops", element: <Shops /> },
  { path: "/products", element: <Products /> },
  { path: "/update-products/:id", element: <UpdateProduct /> },
  { path: "/product-craete", element: <CreateProduct /> },
  { path: "/category", element: <Category /> },
  { path: "/variants", element: <Variants /> },
  { path: "/attributes", element: <Attributes /> },
  { path: "/settings", element: <Settings /> },
  { path: "/draft-orders", element: <DraftOrders /> },
  { path: "/consumers", element: <Consumers /> },
  { path: "/qr-scanner", element: <QRScanner /> },
  { path: "*", element: <Navigate to="/" /> },
];
export default protectedRoutes;
